import { url as urlHelper } from '@/helpers';
import FailedFolder from '@/models/FailedFolder';
import PaginatedList from '@/models/PaginatedList';
import { AxiosResponse } from 'axios';
import { fetchWrap, offlineResponse } from '../_helpers';

interface FailedFolderQuery {
    searchQuery?: string;
    limit?: number;
    offset?: number;
}

export default {
    /**
     * Get all folderLogs
     * @returns (async) Returns a PaginatedList of folderLogs if the request was successful, otherwise a Response.
     */
    async getAll(searchQuery: string = '', limit: number = 100, offset: number = 0) {
        const query: FailedFolderQuery = {
            searchQuery,
            limit,
            offset,
        };
        const url = urlHelper('/api/failedFolder', query);
        let response: AxiosResponse;
        try {
            response = await fetchWrap(url);
        } catch {
            response = offlineResponse();
        }
        if (response?.status < 300 && response?.status >= 200) {
            const data = response.data;
            const model = new PaginatedList(data);
            model.data = data.data.map((x: any) => new FailedFolder(x));

            return model;
        } else {
            return response;
        }
    },
    async update(model: FailedFolder) {
        const url = `/api/failedFolder/${model.id}`;
        let response: AxiosResponse;

        try {
            response = await fetchWrap(url, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(model),
            });
        } catch {
            response = offlineResponse();
        }
        if (response?.status < 300 && response?.status >= 200) {
            return model;
        } else {
            return response;
        }
    },
    async updateResolved(model: FailedFolder) {
        const url = `/api/failedFolder/${model.id}/resolve`;
        let response: AxiosResponse;

        try {
            response = await fetchWrap(url, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(model),
            });
        } catch {
            response = offlineResponse();
        }
        if (response?.status < 300 && response?.status >= 200) {
            return model;
        } else {
            return response;
        }
    },
};
